import { render } from "./ActivatePromocodeForm.vue?vue&type=template&id=71d1ae6d"
import script from "./ActivatePromocodeForm.vue?vue&type=script&lang=js"
export * from "./ActivatePromocodeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__